import { AbstractFilterHandler } from '@/helpers/filter/AbstractFilterHandler';
import { FilterOptions } from '@/helpers/filter/models/FilterOptions';
import { FilterData } from '@/helpers/filter/models/FilterData';
import type { Lesson } from '@/models/lesson';
import type { XLesson } from '@/models/xlesson';

export class TagFilterHandler extends AbstractFilterHandler {
    public handle(data: FilterData[], filterOptions: FilterOptions): FilterData[] {
        const arr = JSON.parse(JSON.stringify(data)) as FilterData[];
        let res: FilterData[];

        const tagFilterLesson = (lessons: Lesson[]): Lesson[] => {
            return lessons.filter((lesson: Lesson) => {
                if (lesson.sub_lessons) {
                    lesson.sub_lessons = tagFilterLesson(lesson.sub_lessons);
                }

                const hasTag = lesson.tags ? lesson.tags.some((tag) => tag.id === filterOptions.tag.id) : false;
                return hasTag || lesson.sub_lessons.length > 0;
            });
        };

        const tagFilterXLesson = (xLessons: XLesson[]): XLesson[] => {
            return xLessons.filter((lesson: XLesson) => {
                if (lesson.sub_lessons) {
                    lesson.sub_lessons = tagFilterXLesson(lesson.sub_lessons);
                }

                const hasTag = lesson.tags ? lesson.tags.some((tag) => tag.id === filterOptions.tag.id) : false;
                return hasTag || lesson.sub_lessons.length > 0;
            });
        };

        if (filterOptions.tag !== undefined && filterOptions.tag.id !== 0) {
            res = arr.filter((el: FilterData) => {
                if (!filterOptions.tag) {
                    return el;
                }

                if (el.x_lessons) {
                    el.x_lessons = tagFilterXLesson(el.x_lessons);
                } else if (el.lessons) {
                    el.lessons = tagFilterLesson(el.lessons);
                }

                return el;
            });
        } else {
            res = arr;
        }

        return super.handle(res, filterOptions);
    }
}
